export const serviceAreas = [
  "Mumbai, Maharashtra",
  "Thane, Maharashtra",
  "Kalyan, Maharashtra",
  "Navi Mumbai, Maharashtra"
];